export const SEGMENT_IDS = ['humanteq', 'break_up'] as const
export type SegmentId = typeof SEGMENT_IDS[number]
export const isSegmentId = (value: unknown): value is SegmentId =>
  typeof value === 'string' && SEGMENT_IDS.some((id) => id === value)

export interface RegistrationDraft {
  id: string
  readyToSubmit?: boolean
  segment: SegmentId
  scenarioId: string
  version: number
  answers: Record<string, unknown>
}
